import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

export function getSimulatorAssets(filterValues, pager) {
  return get(
    `${url}/asset/simulator?financingPeriod=${filterValues.financingPeriod}&minPayment=${filterValues.monthlyRate[0]}
    &maxPayment=${filterValues.monthlyRate[1]}&advance=${filterValues.advance}&assetTypeId=${filterValues.assetTypeId}&orderByDescending=${filterValues.isSortDescending}&page=${pager.page}&pageSize=${pager.pageSize}`
  );
}

export function getSimulationsInMemory(simulationValues) {
  return post(url + "/leasingoffers/offer-simulations-in-memory", simulationValues);
}

export function saveOfferFromSimulator(offer) {
  return post(url + "/leasingoffers/start-create-offer-from-simulator-workflow", offer);
}

export function createKycSession(kycData) {
  return post(url + "/leasingoffers/create-kyc-session", kycData);
}
